export const checkIfSubscribed = (tag, userData) => {    
    if(userData.subscribedTags && userData.subscribedTags.length && tag){
        return userData.subscribedTags.some(t => (t.tag || "").toLowerCase() === tag.toLowerCase())
    }
    return false
}
